import InnerComponent from '@Components/Sales/IncomingPayments/CreateIncomingPayment';
import orgContainer from '@Components/AppContainer';

const CreateIncomingPayment = () => ((orgContainer(InnerComponent)));
export default CreateIncomingPayment;
